module.exports = __webpack_public_path__ + "img/soft-drinks.073fcbe3.jpg";